import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import classes from "../../assets/styles/CustomURLModal.module.css";
import { MdClose } from "react-icons/md";
import SecondLoader from "../../components/SecondLoader";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../../pages/CheckoutForm";
import { Button, Form } from "react-bootstrap";
import { post } from "../../server";
import { CREATE_SUBSCRIPTION } from "../../utils/constants/apiUrl";
import { useAtom } from "jotai";
import { loggedInUser } from "../../utils/store";
const SubscriptionModal = ({
  show,
  stripePromise,
  handleCloseModal,
  selectedPackage,
  elementsOptions,
  selectedSubscriptionType,
  couponData,
  incorrectCouponEntered,
  correctCouponEntered,
  setCouponData,
  blankCouponField,
  setBlankCouponField,
}) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [errors, setErrors] = useState({});
  const [loading, setIsLoading] = useState(false);
  const [payOptions, setPayOptions] = useState("stripe");
  const checkbox = useRef();
  // Handle Update

  const handlePaypalSubscription = async () => {
    let amount =
      selectedSubscriptionType === "monthly" || selectedPackage.id === 5
        ? selectedPackage?.price_monthly
        : selectedSubscriptionType === "yearly"
        ? selectedPackage?.price_yearly
        : selectedPackage.price;
    let couponCode = null;
    let couponCodeId = null;
    let discount = 0;
    let discountAmount = 0;
    if (couponData && couponData.coupons_applied_status) {
      couponCode = couponData?.coupon_code;
      couponCodeId = couponData?.coupon_code_id;
      discount = couponData?.discount_percentage;
      discountAmount = couponData?.discount_amt;
      amount = couponData?.package_price_after_discount;
    }
    const payload = {
      amount: amount,
      auto_renew: checkbox.current.checked ? true : false,
      package_id: selectedPackage?.id,
      coupon_code: couponCode,
      coupon_code_id: couponCodeId,
      subscription_type: selectedSubscriptionType || "monthly",
    };
    const { status, message, data } = await post(
      CREATE_SUBSCRIPTION,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      // redirect to PayPal checkout URL
      window.location.href = data.url;
    } else {
      // handle error gracefully
      console.error("Subscription failed:", message);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => {
          handleCloseModal();
          setErrors({});
        }}
        className="customModal square-modal"
        size="sm"
      >
        <Modal.Header
          className="modalHeader flex justify-content-between"
          style={{ borderBottom: "none", width: "fit-content" }}
        >
          {selectedPackage.id !== 1 ? (
            <span className="modalHeading">Card Details</span>
          ) : (
            <span
              className="modalHeading"
              style={{ fontWeight: "600", color: "var(--primary_text_color)", fontSize: "20px" }}
            >
              Like to Downgrade?
            </span>
          )}
          <div className="modalGradientCircle"></div>
          {/* <MdClose
            onClick={() => {
              handleCloseModal();
              setErrors({});
            }}
            className="modalCloseBtn"
          /> */}
        </Modal.Header>
        {loading ? (
          <SecondLoader />
        ) : (
          <>
            <Modal.Body className="pt-0">
              <div className="form-group mb-0">
                <label>Select Payment Method</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payOptions"
                      value="stripe"
                      onChange={(e) => setPayOptions(e.target.value)}
                      checked={payOptions === "stripe"} // controlled
                    />
                    <label className="form-check-label">Stripe</label>
                  </div>
                  {/* {selectedPackage?.package_type !==
                    "customer_specific_personal" && (
                    <div class="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="payOptions"
                        value="paypal"
                        onChange={(e) => setPayOptions(e.target.value)}
                        checked={payOptions === "paypal"}
                      />
                      <label className="form-check-label">Paypal</label>
                    </div>
                  )} */}
                </div>
              </div>

              <div className="d-flex flex-column align-items-center justify-content-center text-center">
                {payOptions === "stripe" ? (
                  <>
                    <Elements stripe={stripePromise} options={elementsOptions}>
                      <CheckoutForm
                        selectedPackage={selectedPackage}
                        handleCloseModal={handleCloseModal}
                        selectedSubscriptionType={selectedSubscriptionType}
                        couponData={couponData}
                      />
                    </Elements>
                  </>
                ) : payOptions === "paypal" ? (
                  <>
                    <div className="autoCheckbox text-start mt-3 form-group mb-0 w-100">
                      <Form.Check
                        type="checkbox"
                        id={`default-checkbox`}
                        label={`Auto Subscription`}
                        // onChange={handleAutoCheck}
                        ref={checkbox}
                      />
                    </div>
                    <div
                      className="mobileViewWrapper d-block text-end"
                      style={{ marginTop: "50px" }}
                    >
                      <Button
                        variant="outline-primary"
                        onClick={handleCloseModal}
                        className="mx-3"
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        // disabled={
                        //   !stripe ||
                        //   isLoading ||
                        //   (selectedPackage.id === 1 && !isChecked)
                        // }
                        className="payBtn"
                        onClick={handlePaypalSubscription}
                      >
                        Next
                      </Button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </Modal.Body>
          </>
        )}
      </Modal>
    </>
  );
};

export default SubscriptionModal;
